import { PUBLIC_EVENTS, EVENT_CALLBACK, PRIVATE_EVENTS } from './constants';

export default class EventManager {
  constructor(options) {
    this.privateCallbackSubscriber = [];
    this.publicCallbackSubscriber = [];
  }

  unSubscribeToEvents = (componentName) => {
    this.privateCallbackSubscriber = this.privateCallbackSubscriber.filter(
      (subscriber) => subscriber.senderName !== componentName
    );
    this.publicCallbackSubscriber = this.publicCallbackSubscriber.filter(
      (subscriber) => subscriber.senderName !== componentName
    );
  };

  subscribeToEvents({ eventType, eventCallback, senderName = '', isSync = false, needVerbose = true }) {
    switch (eventType) {
      case EVENT_CALLBACK.PRIVATE_EVENTS:
        this.privateCallbackSubscriber.push({
          eventCallback,
          senderName,
          isSync,
          needVerbose,
        });
        break;
      case EVENT_CALLBACK.PUBLIC_EVENTS:
        this.publicCallbackSubscriber.push({
          eventCallback,
          senderName,
          isSync,
          needVerbose,
        });
        break;
    }
  }

  handleSubscriber = (subscriberArray, eventName, eventData, options) => {
    for (const element of subscriberArray) {
      if (typeof element.eventCallback === 'function') {
        if (element.isSync || eventData?.isSync) {
          element.eventCallback(eventName, eventData, options);
        } else
          ((evtName, evtData, opt) => {
            setTimeout(() => {
              element.eventCallback(evtName, evtData, opt);
            }, 0);
          })(eventName, eventData, options);
      }
    }
  };

  broadcastPrivateEvent = (event, eventData, options = null) => {
    this.handleSubscriber(this.privateCallbackSubscriber, event, eventData, options);
  };

  broadcastPublicEvent = (event, eventData, options = null) => {
    this.handleSubscriber(this.publicCallbackSubscriber, event, eventData, options);
  };
}
